import { render, staticRenderFns } from "./ShowAccountingDoc.vue?vue&type=template&id=22b8165d&"
import script from "./ShowAccountingDoc.vue?vue&type=script&lang=js&"
export * from "./ShowAccountingDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports